// Iter 229/240 (Kamel) — Bloc « Installez l'application » dans l'Espace Adhérent :
// tout est mâché (adresse du site incluse, étapes numérotées par appareil) pour que
// n'importe qui y arrive. Une fois installée, l'appli ouvre DIRECTEMENT leur espace.
import React, { useEffect, useState } from 'react';

export const InstallAppBlock = ({ defaultOpen = false }) => {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (standalone || localStorage.getItem('raavInstalled') === '1') { setInstalled(true); return undefined; }
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { localStorage.setItem('raavInstalled', '1'); setInstalled(true); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => { window.removeEventListener('beforeinstallprompt', onPrompt); window.removeEventListener('appinstalled', onInstalled); };
  }, []);

  if (installed) return null;
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  // Iter 270b (Kamel) — Chrome sur iPhone : Partager en HAUT à droite (iOS 16.4+)
  const isIOSChrome = isIOS && /crios/i.test(navigator.userAgent);
  // Iter 270 (Kamel) — TOUJOURS l'adresse officielle : ne jamais propager
  // l'adresse technique de préversion (emergentagent.com) aux adhérents.
  const adresse = 'rhoneamitievoyages.fr';

  const Etape = ({ n, children }) => (
    <li className="flex items-start gap-2">
      <span className="flex-shrink-0 w-5 h-5 rounded-full bg-emerald-600 text-white text-[11px] font-bold flex items-center justify-center mt-0.5">{n}</span>
      <span className="text-xs text-emerald-950 leading-snug">{children}</span>
    </li>
  );

  // Iter 755 (Kamel, Turin J-1) — iPhone : la procédure COMPLÈTE, de l'icône jusqu'aux notifications et au QR code.
  const SuiteIphone = () => (
    <>
      <Etape n="5">Ouvrez l'appli <strong>depuis cette nouvelle icône</strong> (pas depuis Safari). La <strong>1ʳᵉ fois</strong> : entrez votre email, puis le <strong>code à 6 chiffres</strong> reçu par email. Ensuite elle s'ouvrira <strong>directement sur votre espace</strong> 🎉</Etape>
      <Etape n="6">Dans l'appli, rubrique <strong>« 🔔 Mes notifications »</strong> → <strong>Activer les notifications</strong> → votre iPhone demande <strong>« Autoriser »</strong> : appuyez sur <strong>Autoriser</strong>. (Nécessite iOS 16.4 ou plus : Réglages → Général → Mise à jour logicielle.)</Etape>
      <Etape n="7">Vérifiez : appuyez sur <strong>« M'envoyer une notification test »</strong>. Rien reçu ? Réglages de l'iPhone → <strong>Notifications</strong> → <strong>Rhône Alpes Amitié</strong> → Autoriser les notifications.</Etape>
      <Etape n="8">Le jour du départ, ouvrez l'appli : votre <strong>🎫 QR code d'embarquement</strong> est tout en haut. Appuyez sur « Afficher en grand », montez la luminosité et montrez-le à l'accompagnateur.</Etape>
    </>
  );

  return (
    <div className="bg-white rounded-2xl shadow overflow-hidden" data-testid="espace-install-app-block">
      <button onClick={() => setOpen(v => !v)} data-testid="install-app-toggle"
        className="w-full text-left px-4 py-3.5 flex items-center justify-between gap-2 hover:bg-emerald-50">
        <span className="min-w-0">
          <span className="text-sm font-bold text-emerald-900">📲 Installer l'application sur mon téléphone</span>
          <span className="block text-[11px] text-gray-500 mt-0.5">Gratuit, 30 secondes — votre espace s'ouvre en un seul appui. Appuyez pour voir comment faire</span>
        </span>
        <span className="text-emerald-800 font-bold text-lg flex-shrink-0">{open ? '▴' : '▾'}</span>
      </button>
      {open && (
      <div className="px-4 pb-4">
      <div className="bg-emerald-50 border border-emerald-300 rounded-xl p-3">
      <p className="text-xs text-emerald-800">
        Une icône <strong>Rhône Alpes Amitié</strong> apparaîtra sur votre écran, comme WhatsApp :
        un seul appui et <strong>votre espace s'ouvre tout seul</strong> — plus jamais besoin d'email ni de lien.
        Et vous recevrez les notifications : heure du car, rappels d'enveloppes, photos des excursions…
      </p>
      <a href={`https://www.${adresse}`} target="_blank" rel="noreferrer"
        className="text-xs font-bold text-emerald-900 mt-2 bg-white border border-emerald-300 rounded-lg px-2.5 py-1.5 inline-block hover:bg-emerald-100"
        data-testid="install-app-adresse">
        🌐 Notre site — appuyez ici : <span className="text-[#1E3A5F] underline">www.{adresse}</span>
      </a>
      {prompt ? (
        <div className="mt-3">
          <button onClick={async () => { prompt.prompt(); const c = await prompt.userChoice; if (c.outcome === 'accepted') { localStorage.setItem('raavInstalled', '1'); setInstalled(true); } }}
            className="text-sm font-bold px-4 py-2.5 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 shadow"
            data-testid="espace-install-app-btn">
            📲 Installer l'application maintenant
          </button>
          <p className="text-[11px] text-emerald-700 mt-1.5">Un seul appui sur ce bouton, votre téléphone fait le reste !</p>
        </div>
      ) : (
        <ol className="mt-3 space-y-1.5" data-testid="install-app-etapes">
          {isIOS ? (
            isIOSChrome ? (
              <>
                <Etape n="1">Vous y êtes déjà 👍 (sinon : ouvrez <strong>Chrome</strong> et tapez <strong>www.{adresse}</strong>)</Etape>
                <Etape n="2">Appuyez sur le bouton <strong>Partager</strong> <span aria-hidden>⬆️</span> (le carré avec la flèche, <strong>en haut à droite</strong> à côté de la barre d'adresse)</Etape>
                <Etape n="3">Faites défiler et choisissez « <strong>Ajouter à l'écran d'accueil</strong> », puis appuyez sur <strong>Ajouter</strong></Etape>
                <Etape n="4">Appuyez sur <strong>OK</strong> si votre iPhone demande une confirmation, puis <strong>fermez Chrome</strong></Etape>
                <SuiteIphone />
              </>
            ) : (
              <>
                <Etape n="1">Vous y êtes déjà 👍 (sinon : ouvrez <strong>Safari</strong> et tapez <strong>www.{adresse}</strong>)</Etape>
                <Etape n="2">Appuyez sur le bouton <strong>Partager</strong> <span aria-hidden>⬆️</span> (le carré avec la flèche, en bas au milieu de l'écran)</Etape>
                <Etape n="3">Faites défiler et choisissez « <strong>Sur l'écran d'accueil</strong> », puis appuyez sur <strong>Ajouter</strong></Etape>
                <Etape n="4">L'icône <strong>Rhône Alpes Amitié</strong> apparaît sur votre écran d'accueil (parfois sur la page suivante : balayez vers la gauche). <strong>Fermez Safari.</strong></Etape>
                <SuiteIphone />
              </>
            )
          ) : (
            <>
              <Etape n="1">Vous y êtes déjà 👍 (sinon : ouvrez <strong>Chrome</strong> et tapez <strong>www.{adresse}</strong>)</Etape>
              <Etape n="2">Appuyez sur les <strong>3 petits points ⋮</strong> en haut à droite de l'écran</Etape>
              <Etape n="3">Choisissez « <strong>Installer l'application</strong> » (ou « <strong>Ajouter à l'écran d'accueil</strong> »), puis confirmez</Etape>
              <Etape n="4">C'est fait ! L'icône <strong>Rhône Alpes Amitié</strong> est sur votre écran : elle ouvrira <strong>directement votre espace</strong> 🎉</Etape>
            </>
          )}
        </ol>
      )}
      </div>
      <button onClick={() => setOpen(false)} data-testid="install-app-replier-bas"
        className="w-full mt-3 text-center text-xs font-bold text-[#1E3A5F] bg-gray-50 border border-gray-200 rounded-xl py-2.5 hover:bg-gray-100">
        ▴ Replier cette rubrique
      </button>
      </div>
      )}
    </div>
  );
};

export default InstallAppBlock;
